import PopupCloseButton from '../../utils/PopupCloseButton';
import PlatformModalLayer from '../../utils/PlatformModalLayer';
import ConfirmationHeroModal from '../../utils/ConfirmationHeroModal.jsx';
import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from "react";
import { FaRobot, FaTimes, FaExclamationTriangle } from "react-icons/fa";
import { InfoHexIcon, SettingsHexIcon } from "./TableActionIcons.jsx";
import PanelSkeleton from '../../utils/PanelSkeleton';
import { useAccountManagerContext } from "../../../contexts/Account-Manager-Context.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import { useMetricsContext } from "../../../contexts/Metrics-Context.js";
import { useChartContext } from "../../../contexts/Chart-Context.js";
import { Position } from "../../../interfaces/Position.js";
import { Order } from "../../../interfaces/Order.js";
import '../metrics_panel/Metrics-Panel.scss';
import { Ripple } from '../../utils/PopupRipple.jsx';
import 'react-ripple-click/dist/index.css';
import Select from "../../utils/Select.jsx";
import { MdExitToApp } from "react-icons/md";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import useLongPress from "../../../lib/hooks/useLongPress.js";
import { useTranslation } from "react-i18next";
import { translateDirection } from "../../../i18n/directionLabel.js";
import { dropdownOptionStyle } from "../../../utils/dropdownOptionStyles.js";


// import Positions from './Positions'
// import MarketOrder from "../market_order/Market-Order.tsx";
import {
  API_ENDPOINT_CLOSED_POSITIONS,
  API_ENDPOINT_OPENED_ORDERS,
  API_ENDPOINT_OPENED_POSITIONS,
  API_ENDPOINT_CLOSED_ORDERS,
  API_ENDPOINT_CLOSE_ALL_POSITIONS,
  API_ENDPOINT_GET_POSITION_DETAILS,
  API_ENDPOINT_All_CLOSED_POSITIONS,
} from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import "./Account-Manager.scss";
import { adjustDateTime, formatDate, formatDigitBasePrice, formatPrice, formatFixedTrimmed } from "../../../utils/format.js";
import { WS_ENDPOINT_ACCOUNT_DETAILS } from "../../../data/Endpoints-WS.js";
import { ws_create } from "../../../data/websocket/Websocket-Middleware.js";
import { log } from "console";
import { useOrderContext } from "../../../contexts/Order-Context.js";
import EditSltp from "../edit_sltp_modal/Edit-Sltp.tsx";
import { useMatches } from "react-router-dom";
import PositionHistory from "./PositionHistory.jsx";
import OrderHistory from "./OrderHistory.jsx";
import Orders from "./Orders.jsx";
import DataTable, {createTheme} from "react-data-table-component";
// import MetricsPanel from "../metrics_panel/Metrics-Panel.jsx"; // Replaced by AccountStatsBar.
import { TbZip } from "react-icons/tb";
import BotPositionHistory from "./BotPositionHistory.jsx";
import StrategiesTab from "../ea/StrategiesTab.jsx";
import useEaModuleVisible from "../ea/useEaModuleVisible.js";
import { start } from "repl";
import PositionEvent from "./PositionEvent.jsx";
import useTableHScrollPin from "./useTableHScrollPin.js";
import NoRecordsMessage from "../../utils/NoRecordsMessage.jsx";

// function chunkArray(array: any[], size: number) {
//   const chunkedArray: any[][] = [];
//   for (let i = 0; i < array.length; i += size) {
//     chunkedArray.push(array.slice(i, i + size));
//   }
//   return chunkedArray;
// }
function chunkArray(array, size) {
  let size2 = size;
  if (!Array.isArray(array)) {
    console.log('Please provide a valid array (in chunkArray function positions)');
    return [];
  }
  if (typeof size2 !== 'number' || size2 <= 0) {
    // throw new TypeError('Size should be a positive number');
    size2 = 5;
  }

  const chunkedArray: any[][] = [];
  for (let i = 0; i < array.length; i += size2) {
    chunkedArray.push(array.slice(i, i + size2));
  }
  return chunkedArray;
}

interface AccountManagerProps {
  mobileMode: boolean;
}

const AccountManager: React.FC<AccountManagerProps> = ({mobileMode: initialMobileMode}) => {
  const [mobileMode, setMobileMode] = useState(initialMobileMode);
  useEffect(() => {
    const screen = window.matchMedia('(max-width: 960px)');
    const sync = () => setMobileMode(screen.matches);
    sync();
    screen.addEventListener('change', sync);
    return () => screen.removeEventListener('change', sync);
  }, []);
  const { t } = useTranslation();
  const { updateMetrics, metrics,utcOffset, setShowDealsModal, showDealsModal, userCurrencyExchangeRate} = useMetricsContext();
  const { selectedStyle, setSelectedStyle, styleOptions } = useChartContext();
  const buttonRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const ordersDivRef = useRef<HTMLDivElement>(null);
  const orderHistoryDivRef = useRef<HTMLDivElement>(null);
  const positionsTableScrollRef = useRef<HTMLDivElement>(null);
  useTableHScrollPin(positionsTableScrollRef);

  const [isSymbolSelecting, setIsSymbolSelecting] = useState(false);
  const [currActiveTab, setCurrActiveTab] = useState(0);
  const [radioChecked, setRadioChecked] = useState(true);
  const [radioChecked2, setRadioChecked2] = useState(true);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [selectDisabled2, setSelectDisabled2] = useState(false);
  const [direction, setDirection] = useState("all");
  const [firstdirection, setFirstdirection] = useState("all");
  const [botFilter, setBotFilter] = useState("all");


  const [selectedPositionView, setSelectedPositionView] = useState(null);
  const [selectedTableRowId, setSelectedTableRowId] = useState(null);
  const [openOrdersCountM, setOpenOrdersCountM] = useState(0)
  const [openOrdersCountD, setOpenOrdersCountD] = useState(0)
  const today = new Date(); // Get today's date
  const [filterDate, setFilterDate] = useState<{ startDate: Date | null, endDate: Date | null }>({ startDate: null, endDate: null });
  const [orderDate, setOrderDate] = useState<{ startDate: Date | null, endDate: Date | null }>({ startDate: null, endDate: null });
  const [selPositionId, setSelPositionId] = useState([])
  const [selectedDateState, setSelectedDateState] = useState('all');
  const [selectedOrderDate, setselectedOrderDate] = useState('all');
  const [startingDate, setStartingDate] = useState<{ startDate: Date | null, endDate: Date | null }>({ startDate: null, endDate: null });
  const [positionDealsInfo, setPositionDealsInfo] = useState([]);
  const modalBottom = useRef(null);
  const [bulkOperationType, setBulkOperationType] = useState(null);
  const [expandView] = useState(true);
  const isValidNumber = (value) => typeof value === 'number' && !isNaN(value);
  const netPnl = `${isValidNumber(metrics?.totalUnrealizedPnL) ? formatFixedTrimmed(metrics.totalUnrealizedPnL, 2) : 'N/A'}`;


  const handlePositionModal = async  () =>{
    const response = await APIMiddleware.get(API_ENDPOINT_GET_POSITION_DETAILS(user.userId, selectedPosition?.position_id));
    setPositionDealsInfo(response.resp);
    setShowDealsModal(true);
  }
  
  const handleDateChange = (event, key) => {
    const newDate = new Date(event.target.value);
    setStartingDate(prev => ({ ...prev, [key]: newDate }));
  };
  const [datePickar, setDatePickar] = useState<{ startDate: Date | null, endDate: Date | null }>({ startDate: null, endDate: null });
  const datePickarFunction = (event, key) => {
    const newDate = new Date(event.target.value);
    setDatePickar(prev => ({ ...prev, [key]: newDate }));
  };
  const handleFilter = (e) => {
    const value = e.target.value;
    setFilterText(value);
  };
  const handleSelectChange = (selectedOption) => {
    setDirection(selectedOption.value);
  };
  const directionOptions = useMemo(
    () => [
      { value: "all", label: t('filters.allDirections') },
      { value: "Buy", label: t('common.buy') },
      { value: "Sell", label: t('common.sell') },
    ],
    [t],
  );
  const handleOpenOrdersMobile = (newData) => {
    setOpenOrdersCountM(newData);
  };


  const handleBotFilterChange = (selectedValue) => {
    setBotFilter(selectedValue);
  };

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '24px',
      height: '24px',
      width: '124px',
      minWidth: '124px',
      maxWidth: '124px',
      margin: 0,
      borderColor: state.isFocused
        ? `${selectedStyle.buyColor} !important`
        : 'var(--surface-border, #3a4156) !important',
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      borderRadius: '6px',
      boxShadow: 'none',
      cursor: 'pointer',
      alignItems: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: `${selectedStyle.buyColor} !important`,
        boxShadow: 'none',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      paddingLeft: '0',
      margin: '0',
      color: 'var(--content-secondary, #b8bcc8) !important',
      fontSize: '11px',
      lineHeight: '16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 2px 0 6px',
      height: '26px',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '26px',
      alignSelf: 'center',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0 4px',
      color: state.isFocused || state.selectProps.menuIsOpen
        ? `${selectedStyle.buyColor} !important`
        : 'var(--content-secondary, #b8bcc8) !important',
      transition: 'color 0.15s ease',
      transform: 'none',
      '&:hover': {
        color: `${selectedStyle.buyColor} !important`,
      },
      svg: {
        width: '14px',
        height: '14px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transformOrigin: 'center',
      },
    }),
    option: (provided, state) => dropdownOptionStyle(provided, state, {
      padding: '0 12px',
      height: '24px',
      minHeight: '24px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      fontSize: '11px',
      lineHeight: '1.35',
      borderBottom: '1px solid var(--surface-bg, #1a1f36)',
      '&:nth-last-child(1)': {
        borderBottom: 'none !important',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      margin: '0.3rem 0 0 0 !important',
      zIndex: 9999,
      overflow: 'hidden',
      borderRadius: '6px',
      border: '1px solid var(--surface-border, #3a4156)',
      boxShadow: 'none',
      minWidth: '124px',
      width: '124px',
      maxWidth: '124px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '132px',
      minHeight: '3px',
      width: '100%',
      overflowY: 'auto',
      padding: '2px 0',
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(170, 170, 170, 0.45) transparent',
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  const handleOpenOrdersDesktop = (newData) => {
    setOpenOrdersCountD(newData);
  };

  function changehanlde(e) {
    const value = e.target.value;
    setSelectedDateState(value);
    if (value === 'Today') {
      const today = new Date(); // Get today's date
      // First date starting from midnight
      const startDate = new Date(today);
      startDate.setHours(0, 0, 0, 0); // Set time to midnight (0 hours, 0 minutes, 0 seconds, 0 milliseconds)
      // Second date ending at 23:59:59.999
      const endDate = new Date(today);
      endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999 (23 hours, 59 minutes, 59 seconds, 999 milliseconds)

      const dateobj = {
        startDate: startDate,
        endDate: endDate
      };
      setFilterDate(dateobj);
      // console.log("Today", dateobj)
    }
    else if (value === 'Yesterday') {
      const today = new Date(); // Get today's date

      // Subtract one day from today to get yesterday's date
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      // First date starting from midnight
      const startDate = new Date(yesterday);
      startDate.setHours(0, 0, 0, 0); // Set time to midnight (0 hours, 0 minutes, 0 seconds, 0 milliseconds)

      // Second date ending at 23:59:59.999
      const endDate = new Date(yesterday);
      endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999 (23 hours, 59 minutes, 59 seconds, 999 milliseconds)

      yesterday.setDate(today.getDate() - 1);
      const dateobj = {
        startDate: startDate,
        endDate: endDate
      };
      setFilterDate(dateobj);
      // console.log("Yesterday", dateobj)

    }

    else if (value === 'CurrentWeek') {
      const today = new Date();
      const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay())); // Get the start of the current week (Sunday)
      const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6)); // Get the end of the current week (Saturday)

      const dateobj = {
        startDate: startOfWeek,
        endDate: endOfWeek
      };
      setFilterDate(dateobj);

      // console.log("current week:", dateobj);
    }

    else if (value === 'CurrentMonth') {
      const today = new Date(); // Get today's date
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the month
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the month

      const dateobj = {
        startDate: firstDayOfMonth,
        endDate: lastDayOfMonth
      };

      setFilterDate(dateobj);

      // Now you can use `monthData` to filter your data for the current month
      // console.log("Current Month:", dateobj);
    }
    else if (value === 'PreviousMonth') {
      const today = new Date(); // Get today's date
      const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the current month
      const firstDayOfPreviousMonth = new Date(firstDayOfCurrentMonth); // Copy the date
      firstDayOfPreviousMonth.setMonth(firstDayOfPreviousMonth.getMonth() - 1); // Set it to the previous month
      const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth); // Copy the date again
      lastDayOfPreviousMonth.setDate(0); // Set it to the last day of the previous month

      const dateobj = {
        startDate: firstDayOfPreviousMonth,
        endDate: lastDayOfPreviousMonth
      };

      setFilterDate(dateobj);

      // console.log("Last Month:", dateobj);
    }

    else if (value === 'LastThreeMonths') {
      const today = new Date(); // Get today's date
      const firstDateThirdMonthAgo = new Date(today.getFullYear(), today.getMonth() - 3, 1); // First day of the third last month
      const lastDateLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

      const dateobj = {
        startDate: firstDateThirdMonthAgo,
        endDate: lastDateLastMonth
      };

      setFilterDate(dateobj);

      // console.log("Last 3 Month:", dateobj);
    }
    else if (value === 'Last6Months') {
      const today = new Date(); // Get today's date
      const firstDateThirdMonthAgo = new Date(today.getFullYear(), today.getMonth() - 6, 1); // First day of the third last month
      const lastDateLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

      const dateobj = {
        startDate: firstDateThirdMonthAgo,
        endDate: lastDateLastMonth
      };

      setFilterDate(dateobj);
      // console.log("Last 6 Month:", dateobj);
    }

    else if (value === 'all') {
      // setFilterDate(null);
      // console.log("Last 6 Month:", dateobj);
    }
    else {
      //setFilterDate('all');
    }
  }

    const MobilePositionRow = ({ position, isExpanded, onToggle, onLongPressTrigger }) => { 
      const handleLongPress = () => {
        // Only trigger for non-bot positions
        if (position.is_bot_trade !== 1) {
          onLongPressTrigger(position);
        }
      };

      const {
        handlers,
        isLongPress,
        cancel: cancelLongPress
      } = useLongPress(handleLongPress, 100);

      const handleClick = () => {
        if (isLongPress()) return;
        onToggle();
      };
      return (
        <div className={`mobile-position-row ${isExpanded ? 'expanded' : ''} ${Number(position.is_bot_trade) === 1 ? 'bot-position' : ''}`}>
          <div onClick={handleClick} {...handlers} onTouchStart={handlers.onTouchStart}>
            <div className="main-row">
              <div className="left-section">
                <div className="symbol-direction">
                  {Number(position.is_bot_trade) === 1 && (
                    <FaRobot className="bot-icon" style={{ 
                      color: 'var(--content-secondary, #b8bcc8)',
                      fontSize: '14px'
                    }} />
                  )}
                  {Number(position.is_bot_trade) === 2 && (
                    <span className="ea-type-badge" data-tooltip={t('actions.expertAdvisor')}>EA</span>
                  )}
                  <span className="symbol-name">{position.symbol}</span>
                  <span
                    style={{
                      color:
                        position.direction?.toLowerCase() === 'buy'
                          ? selectedStyle.buyColor
                          : selectedStyle.sellColor
                    }}
                  >
                    {translateDirection(position.direction, t)}
                  </span>
                  <span className="quantity">{formatFixedTrimmed(Number(position.quantity), 8)}</span>
                </div>
                <div className="price-movement">
                  {formatFixedTrimmed(position.entry_price, 8)} → {position.current_price != null ? formatFixedTrimmed(position.current_price, 8) : '-'}
                </div>
              </div>
              <div
                style={{
                  color:
                    position.pnl >= 0
                      ? selectedStyle.buyColor
                      : selectedStyle.sellColor
                }}
              >
                {!isNaN(Number(position.pnl))
                  ? formatFixedTrimmed(Number(position.pnl), 2)
                  : '---'}
              </div>
            </div>

            {isExpanded && (
              <div className="expanded-section">
                <div className="created-at">
                  {formatDate(adjustDateTime(position.created_at, utcOffset))}
                </div>
                <div className="row">
                  <div className="half-row">
                    <span className="label">S/L:</span>
                    <span className="value">
                      {position.SL ? formatFixedTrimmed(position.SL, 8) : '--'}
                    </span>
                  </div>
                  <div className="half-row">
                    <span className="label">T/P:</span>
                    <span className="value">
                      {position.TP ? formatFixedTrimmed(position.TP, 8) : '--'}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="half-row">
                    <span className="label">Margin:</span>
                    <span className="value">{formatFixedTrimmed(position.margin, 4)}</span>
                  </div>
                  <div className="half-row">
                    <span className="label">ID:</span>
                    <span className="value">{`PID${position.position_id.toString().padStart(8, "0")}`}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    };


  const MobilePositionsList = ({ positions }) => {
    const toggleRow = (positionId) => {
      setExpandedRows(prev => ({
        ...prev,
        [positionId]: !prev[positionId]
      }));
    };    
    const handleLongPressTrigger = (position) => {
      if (position.is_bot_trade !== 1) {
        setPopupPosition(position);
        setShowClosePopup(true);
      }
    };
  
    return (
      <>
        <div className="mobile-positions-container">
          <div className="ellipsis-header">
            <button aria-label={t('actions.bulkOperations')} className="ellipsis-btn" onClick={() => setShowCloseAllPopup(true)}>
              ⋯
            </button>
          </div>
          {positions.map(position => (
            <MobilePositionRow
              key={position.position_id}
              position={position}
              isExpanded={expandedRows[position.position_id]}
              onToggle={() => toggleRow(position.position_id)}
              onLongPressTrigger={handleLongPressTrigger}
            />
          ))}
        </div>
        {showCloseAllPopup && (
          <div className="bottom-popup-overlay" onClick={() => setShowCloseAllPopup(false)} ref={modalBottom}>
            <div className="bottom-popup" onClick={(e) => e.stopPropagation()}>
              <h3 className="popup-heading">{t('actions.bulkOperations')}</h3>

              <div className="bulk-buttons-container">
                <button
                  className="bulk-button"
                  onClick={(e) => {
                    clearPopup(e, 'close all positions');
                    setShowCloseAllPopup(false);
                  }}
                >
                  {t('actions.closeAllPositions')}
                  {/* <span className={`${parseFloat(metrics?.totalUnrealizedPnL) >= 0 ? selectedStyle.buyColor : selectedStyle.sellColor} ${expandView && 'multiline-truncate'}`} title={netPnl} >{netPnl}</span> */}
                  <span
                    style={{
                      color: parseFloat(metrics?.totalUnrealizedPnL) >= 0 
                        ? selectedStyle.buyColor 
                        : selectedStyle.sellColor,
                      ...(expandView && { 
                        display: '-webkit-box',
                        WebkitLineClamp: 2,   
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }),
                    }}
                    // title={netPnl}
                  >
                    {netPnl}
                  </span>
                </button>

                {/* Only show the Close Profitable Positions button if there are profitable positions */}
                {openPositions.some(pos => pos.pnl > 0 && !selPositionId.includes(pos.position_id)) && (
                  <button
                    className="bulk-button"
                    onClick={(e) => {
                      setBulkOperationType('profitable');
                      setShowCloseAllPopup(false);
                      setClearWindow("true");
                      setPopupTitle('close profitable positions');
                    }}
                  >
                    {t('actions.closeProfitablePositions')}
                  </button>
                )}

                {/* Only show the Close Losing Positions button if there are losing positions */}
                {openPositions.some(pos => pos.pnl <= 0 && !selPositionId.includes(pos.position_id)) && (
                  <button
                    className="bulk-button"
                    onClick={(e) => {
                      setBulkOperationType('losing');
                      setShowCloseAllPopup(false);
                      setClearWindow("true");
                      setPopupTitle('close losing positions');
                    }}
                  >
                    {t('actions.closeLosingPositions')}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {showClosePopup && popupPosition && popupPosition.is_bot_trade !== 1 && (
          <div className="bottom-popup-overlay2" onClick={() => setShowClosePopup(false)}>
            <div className="bottom-popup2" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-all-button"
                onClick={() => {
                  closeSelectedPosition(popupPosition);
                  setShowClosePopup(false);
                }}
                disabled={selPositionId.includes(popupPosition.position_id)}
              >
                Close Position
              </button>
            </div>
          </div>
        )}
      </>
    );
  };
  function changehanldefunction(e) {
    const value = e.target.value;
    setselectedOrderDate(value);
    if (value === 'Today') {
      const today = new Date(); // Get today's date

      // First date starting from midnight
      const startDate = new Date(today);
      startDate.setHours(0, 0, 0, 0); // Set time to midnight (0 hours, 0 minutes, 0 seconds, 0 milliseconds)

      // Second date ending at 23:59:59.999
      const endDate = new Date(today);
      endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999 (23 hours, 59 minutes, 59 seconds, 999 milliseconds)


      const dateobj = {
        startDate: startDate,
        endDate: endDate
      };
      setOrderDate(dateobj);
      // console.log("Today", dateobj)
    }
    else if (value === 'Yesterday') {
      const today = new Date(); // Get today's date

      // Subtract one day from today to get yesterday's date
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      // First date starting from midnight
      const startDate = new Date(yesterday);
      startDate.setHours(0, 0, 0, 0); // Set time to midnight (0 hours, 0 minutes, 0 seconds, 0 milliseconds)

      // Second date ending at 23:59:59.999
      const endDate = new Date(yesterday);
      endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999 (23 hours, 59 minutes, 59 seconds, 999 milliseconds)

      yesterday.setDate(today.getDate() - 1);
      const dateobj = {
        startDate: startDate,
        endDate: endDate
      };
      setOrderDate(dateobj);
      // console.log("Yesterday", dateobj)
    }

    else if (value === 'CurrentWeek') {
      const today = new Date();
      const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay())); // Get the start of the current week (Sunday)
      const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6)); // Get the end of the current week (Saturday)

      const dateobj = {
        startDate: startOfWeek,
        endDate: endOfWeek
      };
      setOrderDate(dateobj);
      // console.log("current week:", dateobj);
    }

    else if (value === 'CurrentMonth') {
      const today = new Date(); // Get today's date
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the month
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the month

      const dateobj = {
        startDate: firstDayOfMonth,
        endDate: lastDayOfMonth
      };
      setOrderDate(dateobj);
      // Now you can use `monthData` to filter your data for the current month
      // console.log("Current Month:", dateobj);
    }
    else if (value === 'PreviousMonth') {
      const today = new Date(); // Get today's date
      const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the current month
      const firstDayOfPreviousMonth = new Date(firstDayOfCurrentMonth); // Copy the date
      firstDayOfPreviousMonth.setMonth(firstDayOfPreviousMonth.getMonth() - 1); // Set it to the previous month
      const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth); // Copy the date again
      lastDayOfPreviousMonth.setDate(0); // Set it to the last day of the previous month

      const dateobj = {
        startDate: firstDayOfPreviousMonth,
        endDate: lastDayOfPreviousMonth
      };
      console.log('1 months', dateobj);
      setOrderDate(dateobj);
      // console.log("Last Month:", dateobj);
    }

    else if (value === 'LastThreeMonth') {
      const today = new Date(); // Get today's date
      const firstDateThirdMonthAgo = new Date(today.getFullYear(), today.getMonth() - 3, 1); // First day of the third last month
      const lastDateLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

      const dateobj = {
        startDate: firstDateThirdMonthAgo,
        endDate: lastDateLastMonth
      };
      console.log('3 months', dateobj);

      setOrderDate(dateobj);

      // console.log("Last 3 Month:", dateobj);
    }
    else if (value === 'Last6Month') {
      const today = new Date(); // Get today's date
      const firstDateThirdMonthAgo = new Date(today.getFullYear(), today.getMonth() - 6, 1); // First day of the third last month
      const lastDateLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

      const dateobj = {
        startDate: firstDateThirdMonthAgo,
        endDate: lastDateLastMonth
      };
      console.log('6 months', dateobj);

      setOrderDate(dateobj);
      // console.log("Last 6 Month:", dateobj);
    }

    else if (value === 'all') {
      // setOrderDate(null);
      // console.log("Last 6 Month:", dateobj);
    }
    else {
      //setOrderDate('all');
    }
  }
  const handleFirstDivClick = () => {
    setRadioChecked(true);
    setSelectDisabled(false); // Ensure select is enabled when clicking on the first div
  };

  const handleSecondDivClick = () => {
    setRadioChecked(false);
    setSelectDisabled(true); // Disable select when clicking on the second div
  };

  const handleFirstDivClick2 = () => {
    setRadioChecked2(true);
    setSelectDisabled2(false); // Ensure select is enabled when clicking on the first div
  };

  const handleSecondDivClick2 = () => {
    setRadioChecked2(false);
    setSelectDisabled2(true); // Disable select when clicking on the second div
  };

  const handleDateInputClick = (event) => {
    event.stopPropagation(); // Prevent event propagation to avoid affecting div clicks
  };

  const [clearWindow, setClearWindow] = useState("false");
  const [popupTitle, setPopupTitle] = useState();
  const clearPopup = (e, title) => {
    setClearWindow("true");
    setPopupTitle(title);
  };
  const popupAction = (e) => {
    if (popupTitle  === 'close all positions')  {
      clearAllPositions();
    } else if (bulkOperationType === 'profitable') {
      clearAllProfitablePositions();
    } else if (bulkOperationType === 'losing') {
      clearAllLosingPositions();
    }
    setClearWindow("false");
  };

  const [tab, setTab] = useState("1");
  const tabMenu: Element = document.getElementsByClassName("tabs-ah-mb")[0];

  const setTabFunction = (time: number): void => {
    const currentPosition: string | null =
      tabMenu.getAttribute("aria-colcount");
    const indicator: Element = document.getElementsByClassName(
      "active-tab-indicator"
    )[0];
    const tabXData: Element =
      document.getElementsByClassName("tabs-ah-mb-data")[0];

    setTimeout(() => {
      let leftGap: number = 0;
      let currentWidth: string | null = null;

      if (currentPosition !== null) {
        for (let i = 0; i < tabMenu.children.length - 1; i++) {
          if (
            tabMenu.children[i] === tabMenu.children[parseInt(currentPosition)]
          ) {
            currentWidth = getComputedStyle(tabMenu.children[i]).width;
            localStorage.setItem("accountHistory", String(i));
            tabXData.children[i].setAttribute("role", "true");
            tabMenu.children[i].setAttribute("role", "true");

            for (let j = 0; j < i; j++) {
              const currentPrefix: CSSStyleDeclaration = getComputedStyle(
                tabMenu.children[j]
              );
              leftGap += parseInt(currentPrefix.width.split("px")[0]);
            }
          } else {
            tabMenu.children[i].setAttribute("role", "false");
            tabXData.children[i].setAttribute("role", "false");
          }
        }

        if (currentWidth !== null) {
          indicator.style.width = currentWidth;
          indicator.style.left = `${leftGap}px`;
        }
      }
    }, time);
  };

  const filterData = (text, direction, botFilter) => {
    // Sort by created_at descending (newest first) first
    let filteredItems = [...openPositions].sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return dateB - dateA;
    });

    if (botFilter !== 'all') {
      filteredItems = filteredItems.filter((item) => {
        const tag = Number(item?.is_bot_trade) || 0;
        if (botFilter === 'isBot') return tag === 1;
        if (botFilter === 'isEa') return tag === 2;
        if (botFilter === 'nonBot') return tag === 0;
        return true;
      });
    }

    if (direction !== 'all') {
      filteredItems = filteredItems.filter((item) => item.direction === direction);
    }


    if (text) {
      filteredItems = filteredItems.filter(
        (item) => {
          const searchText = text.toLowerCase().replace('pid', '').replace(/^0+/, '');
          return item.symbol.toLowerCase().includes(searchText) || 
             item.position_id.toString().toLowerCase().includes(searchText);
        }
      );
    }
    return filteredItems;
  };

  // useEffect(() => {
  //   if (tabMenu !== undefined) {
  //     setTabFunction(1000);
  //   }

  //   const savedAccountHistory = localStorage.getItem("accountHistory");
  //   if (savedAccountHistory !== null) {
  //     setTab(savedAccountHistory);
  //   }
  // }, [tabMenu]);


  const tabMenuRef = useRef<HTMLDivElement>(null);
  const indicatorRef = useRef<HTMLDivElement>(null);
  const tabXDataRef = useRef<HTMLDivElement>(null);

  const [activeHistoryTab, setActiveHistoryTab] = useState(0);
  const selectTab = (e: number): void => {
    // tabMenu.setAttribute("aria-colcount", e);
    // setTabFunction(0);
    // setCurrActiveTab(e);
    setActiveHistoryTab(e);
  };

  //CONTEXT
  const {
    selectedAuthSymbol,
    openPositions,
    openOrders,
    closedPositions,
    closedOrders,
    closePosition,
    closeOrder,
    cancelOrder,
    setAllOpenPositions,
    setAllOpenOrders,
    setAllClosePositions,
    setAllCloseOrders,
    isClosing,
    isClosingOrder,
    setIsClosing,
    setIsClosingOrder,
    closeAllPosition,
    closeProfitablePositions,
    closeLosingPositions,
    closeAllOrder,
    activeTab,
    setActiveTab,
    isClosingPosition,
    orderHistoryCount,
    positionHistoryCount,
    isClosingAllPositions,
    isCancellingOrder,
    positionCount,
    ordersCount,
    botHistoryPending,
    botPositionHistoryCount,
    totalBotPositionHistoryCount,
    setTotalBotPositionHistoryCount,
    strategiesCount,
  } = useAccountManagerContext();
  const { user, platFromData, setAuthSelectedCategory, setAuthSelectedSymbol, setSelectedAuthSymbolId, isFirstLoginDisabled } = useAuthContext();
  const { symbolData, updateSymbolData, setSelectedCategoryId, setSelectedSymbolSession } = useSymbolContext();

  const botSubscribed = platFromData[7]?.['is_bot_subscribed'] === 1;
  // Show tab when subscribed OR when count > 0 (has history)
  // When subscribed, tab mounts and fetches count. When unsubscribed, tab shows only if count > 0.
  const showBotHistoryTab = botSubscribed || totalBotPositionHistoryCount > 0;
  // Group EA toggle OFF → hide Strategies module (like bot when not subscribed).
  const showEaStrategiesModule = useEaModuleVisible(platFromData?.[5]?.userId);
  const accountTabsRef = useRef<HTMLDivElement>(null);
  const accountTabLineRef = useRef<HTMLSpanElement>(null);
  const [tabOverflow, setTabOverflow] = useState({ overflow: false, left: false, right: false });
  const [loading, setLoading] = useState(true);
  const scrollAccountTabs = (direction: number) => {
    const tabs = accountTabsRef.current;
    tabs?.scrollBy({ left: direction * tabs.clientWidth * 0.75, behavior: 'smooth' });
  };
  useLayoutEffect(() => {
    const tabs = accountTabsRef.current;
    if (loading || !tabs) return;
    const update = () => {
      const maximum = tabs.scrollWidth - tabs.clientWidth;
      const next = { overflow: tabs.scrollWidth > (tabs.parentElement?.clientWidth || tabs.clientWidth) + 1, left: tabs.scrollLeft > 1, right: tabs.scrollLeft < maximum - 1 };
      setTabOverflow(previous => previous.overflow === next.overflow && previous.left === next.left && previous.right === next.right ? previous : next);
    };
    const revealSelected = () => {
      const selected = tabs.querySelector<HTMLElement>('.tab-active-acc');
      if (selected) {
        const rail = tabs.getBoundingClientRect();
        const rect = selected.getBoundingClientRect();
        if (rect.left < rail.left) tabs.scrollLeft += rect.left - rail.left;
        else if (rect.right > rail.right) tabs.scrollLeft += rect.right - rail.right;
      }
      update();
    };
    const observer = new ResizeObserver(revealSelected);
    observer.observe(tabs);
    tabs.querySelectorAll('button.tab-button-acc').forEach(tab => observer.observe(tab));
    tabs.addEventListener('scroll', update, { passive: true });
    revealSelected();
    return () => { observer.disconnect(); tabs.removeEventListener('scroll', update); };
  }, [loading, activeTab, showEaStrategiesModule, showBotHistoryTab]);
  useLayoutEffect(() => {
    if (loading) return;
    const tabs = accountTabsRef.current;
    const line = accountTabLineRef.current;
    if (!tabs || !line) return;

    const TRANSITION = 'transform 300ms cubic-bezier(.2, .7, .2, 1)';

    const readTarget = () => {
      const selected = tabs.querySelector<HTMLButtonElement>('.tab-active-acc');
      if (!selected || !selected.offsetWidth) return null;
      const containerRect = tabs.getBoundingClientRect();
      const selectedRect = selected.getBoundingClientRect();
      const style = getComputedStyle(selected);
      const padL = parseFloat(style.paddingLeft) || 0;
      const padR = parseFloat(style.paddingRight) || 0;
      // Slightly wider than label+badge, but keep a gap before the tab divider.
      const extend = 6;
      const insetL = Math.max(0, padL - extend);
      const insetR = Math.max(0, padR - extend);
      return {
        left: selectedRect.left - containerRect.left + tabs.scrollLeft + insetL,
        width: Math.max(0, selectedRect.width - insetL - insetR),
      };
    };

    // Animate translate + scaleX together so width never snaps after arrival.
    let animating = false;
    let animTimer = 0;
    const measure = (animate: boolean) => {
      if (!animate && animating) return;
      const target = readTarget();
      if (!target || target.width <= 0) return;

      const prevLeft = parseFloat(line.dataset.left || '');
      const prevWidth = parseFloat(line.dataset.width || '');
      const hasPrev = Number.isFinite(prevLeft) && Number.isFinite(prevWidth) && prevWidth > 0;

      line.dataset.left = String(target.left);
      line.dataset.width = String(target.width);

      if (!animate || !hasPrev || line.dataset.ready !== 'true') {
        line.style.transition = 'none';
        line.style.width = `${target.width}px`;
        line.style.transform = `translate3d(${target.left}px, 0, 0) scaleX(1)`;
        return;
      }

      const scale = prevWidth / target.width;
      line.style.transition = 'none';
      line.style.width = `${target.width}px`;
      // Invert: look like previous tab size/position, then play to final.
      line.style.transform = `translate3d(${prevLeft}px, 0, 0) scaleX(${scale})`;
      void line.offsetWidth;
      animating = true;
      window.clearTimeout(animTimer);
      line.style.transition = TRANSITION;
      line.style.transform = `translate3d(${target.left}px, 0, 0) scaleX(1)`;
      animTimer = window.setTimeout(() => { animating = false; }, 320);
    };

    measure(true);
    line.dataset.ready = 'true';

    const observer = new ResizeObserver(() => measure(false));
    observer.observe(tabs);
    tabs.querySelectorAll('button.tab-button-acc').forEach(button => observer.observe(button));
    const onScroll = () => measure(false);
    tabs.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.clearTimeout(animTimer);
      observer.disconnect();
      tabs.removeEventListener('scroll', onScroll);
    };
  }, [loading, activeTab, showEaStrategiesModule, showBotHistoryTab, openOrdersCountD, positionHistoryCount, orderHistoryCount, botPositionHistoryCount, strategiesCount]);

  useEffect(() => {
    if (
      (!showEaStrategiesModule && activeTab === 'ea-strategies') ||
      activeTab === 'ea-positions-history'
    ) {
      setActiveTab('open-positions-acc');
      try {
        localStorage.setItem('accountManager', 'open-positions-acc');
      } catch (_) {}
    }
  }, [showEaStrategiesModule, activeTab, setActiveTab]);

  const [expandedRows, setExpandedRows] = useState({});
  const [showCloseAllPopup, setShowCloseAllPopup] = useState(false);
  const [showClosePopup, setShowClosePopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState(null);
  
  const [filter, setfilter] = useState('');
  const [firstfilter, setfirstfilter] = useState("");
  const [secondfilter, setsecondfilter] = useState("");
  const [thirdfilter, setthirdfilter] = useState("");
  const [isEditSltpVisible, setIsEditSltpVisible] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState({ position_id: null, symbol: '', SL: null, TP: null, quantity: null });
  const [isEdit, setIsEdit] = useState(false);

  const [filterText, setFilterText] = useState('');
  // Derive rows in the same render that receives positions. An effect leaves
  // an empty table visible for one render after loading finishes.
  const filteredData = useMemo(
    () => filterData(filterText, direction, botFilter),
    [openPositions, filterText, direction, botFilter],
  );



  const [filteredCount, setFilteredCount] = useState();

  useEffect(() => {
    const filteredPositions = openPositions.filter((item) => {
      const tag = Number(item?.is_bot_trade) || 0;
      const symbolMatches = filter === '' ? item : item.symbol.toLowerCase().includes(filter.toLowerCase());
      const directionMatches = direction === 'all' ? true : item.direction.toLowerCase() === direction;
      const botFilterMatches =
        botFilter === 'all' ? true :
        botFilter === 'isBot' ? tag === 1 :
        botFilter === 'isEa' ? tag === 2 :
        botFilter === 'nonBot' ? tag === 0 :
        false;

      return symbolMatches && directionMatches && botFilterMatches;
    });

    setFilteredCount(filteredPositions.length);
  }, [filter, openPositions, direction, botFilter]);

  const handleSearchChange = (event) => {
    const filterValue = event.target.value;
    setfilter(filterValue);
  };

  const [filteredOrder, setFilterOrder] = useState("");
useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalBottom.current &&
        !modalBottom.current.contains(event.target)
      ) {
        setShowCloseAllPopup(false);
      }
    }

    if (showCloseAllPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCloseAllPopup]);
  useEffect(() => {

    const filteredPositions = openOrders.filter((item) => {
      const symbolMatches = firstfilter === '' ? item : item.symbol.toLowerCase().includes(firstfilter.toLowerCase());
      const directionMatches = firstdirection === 'all' ? true : item.direction.toLowerCase() === firstdirection;
      return symbolMatches && directionMatches;

    });
    setFilterOrder(filteredPositions.length);
  }, [firstfilter, openOrders, firstdirection]);

  const handleSearchOrder = (event) => {
    const filterValue = event.target.value;
    setfirstfilter(filterValue);
  };

  const [filteredHistory, setFilteredHistory] = useState(closedPositions.length);

  useEffect(() => {
    const filteredPositions = closedPositions.filter(item => {
      const itemDate = new Date(item.position_closed_at);

      // Check if the item passes the date filter based on radioChecked
      if (radioChecked) {
        if (selectedDateState !== "all") {
          return itemDate >= filterDate.startDate && itemDate <= filterDate.endDate;
        } else {
          return true;
        }
      } else {
        if (startingDate.startDate && startingDate.endDate) {
          return itemDate >= startingDate.startDate && itemDate <= startingDate.endDate;
        } else {
          return true;
        }
      }
    }).filter(item => item.symbol.toLowerCase().includes(secondfilter.toLowerCase()));

    setFilteredHistory(filteredPositions.length);
  }, [closedPositions, secondfilter]);

  const handleSearchHistory = (event) => {
    const filterValue = event.target.value;
    setsecondfilter(filterValue);
  };

  const [filteredOrdersCount, setFilteredOrdersCount] = useState(0);

  useEffect(() => {
    const filteredOrders = closedOrders.filter(item => {
      const itemDate = new Date(item.status_updated_at);
  
      // Check if the item passes the date filter based on radioChecked2
      if (radioChecked2) {
        if (selectedOrderDate !== "all") {
          return itemDate >= orderDate.startDate && itemDate <= orderDate.endDate;
        } else {
          return true;
        }
      } else {
        if (datePickar.startDate && datePickar.endDate) {
          return itemDate >= datePickar.startDate && itemDate <= datePickar.endDate;
        } else {
          return true;
        }
      }
    }).filter(item => item.symbol.toLowerCase().includes(thirdfilter.toLowerCase()));
    setFilteredOrdersCount(filteredOrders.length);
  }, [ closedOrders ,thirdfilter]);

    const handleHistoryChange = (event) => {
    const filterValue = event.target.value;
    setthirdfilter(filterValue);
  };

  const botCountFetchedRef = useRef(false);

  // Fetch bot position history count on mount/refresh to update tab visibility
  const fetchBotPositionCount = async () => {
    if (!user || !user.userId || botCountFetchedRef.current) return;
    
    botCountFetchedRef.current = true;
    
    try {
      // Use same date range as BotPositionHistory component
      const startDate = "2000-01-01 00:00:00";
      const today = new Date();
      today.setHours(23, 59, 59, 999);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      const seconds = String(today.getSeconds()).padStart(2, '0');
      const endDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      
      const response = await APIMiddleware.get(
        API_ENDPOINT_All_CLOSED_POSITIONS(
          user.userId,
          1,
          1, // Just need count, not data
          "",
          startDate,
          endDate,
          "isBot" // Filter for bot positions only
        )
      );
      
      if (response && response.totalBotPositions !== undefined) {
        setTotalBotPositionHistoryCount(response.totalBotPositions);
      }
    } catch (error) {
      console.error("Error fetching bot position count:", error);
      botCountFetchedRef.current = false; // Reset on error so it can retry
    }
  };

  useEffect(() => {
    const positionsReady = Array.isArray(platFromData[3]?.openedPositions);
    const ordersReady = Array.isArray(platFromData[4]?.openedOrders);
    if (!user?.userId || !positionsReady || !ordersReady) {
      // The initial platform slots are empty placeholders, not empty responses.
      // Keep the skeleton until both account snapshots have actually arrived.
      setLoading(true);
      return;
    }

    // These map already-received data synchronously. Batch the rows and loading
    // state together so there is no intermediate empty-state render.
    getOpenedPositions();
    getOpenedOrders();
    setLoading(false);
    setIsClosingOrder(false);
  }, [user?.userId, platFromData[3], platFromData[4]]);

  useEffect(() => {
    // Fetch bot position count to update tab visibility (only once)
    fetchBotPositionCount();
    // Reset ref when user changes (new login)
    return () => {
      if (!user || !user.userId) {
        botCountFetchedRef.current = false;
      }
    };
  }, [user?.userId]); // Only depend on userId, not platFromData which changes frequently

  // useEffect(() => {
  //   if (user && user.userId != undefined && user.userId > 0) {
  //     // Calculate and set the initial total P&L when component mounts
  //     // updateTotalPnl();

  //     // if no position is in Closing State then look for SL and TP hit
  //     // if (!isClosing) {
  //     //   checkSLTP();
  //     // }

  //     // if (!isClosingOrder) {
  //     //   checkOrderEntryPrice();
  //     // }

  //     //return () => clearInterval(checkSLTPInterval); // Cleanup on component unmount
  //   }
  // }, [symbolData, selectedAuthSymbol]);
  // useEffect(() => {
  //   if (user && user.userId != undefined && user.userId > 0) {
  //     ws_account.ws_connect(WS_ENDPOINT_ACCOUNT_DETAILS(user?.userId, selectedAuthSymbol), WS_MESSAGE_EVENT_LISTENER);

  //     //handle data got from web-socket message and apply to the component
  //     const handleAccountData = (event) => {
  //       updateAccountData(event.detail);

  //     };

  //     //listen event emit(dispatched) from on-message event of web-socket-middleware
  //     document.addEventListener(WS_MESSAGE_EVENT_LISTENER, handleAccountData);

  //     const updateAccountData = (item) => {
  //       const data = item;
  //     }
  //   }
  // }, [user]);

  // const clearOrder = (e) => {
  //   if(e == 'view'){
  //     document.querySelector(".confirm-box").setAttribute("view", "true");
  //   }
  //   if(e == 'no'){
  //     document.querySelector(".confirm-box").setAttribute("view", "false");
  //   }
  //   if(e == 'ok'){
  //     document.querySelector(".confirm-box").setAttribute("view", "false");
  //     clearAllOrders()
  //   }
  // };

  // Select Symbol Handler
  const handleRowClick = ({ symbol: symbolName }) => {
    if (window.innerWidth < 990 || !symbolName) return;
    if (!symbolData[symbolName]) return;

    updateSymbolData(symbolName, symbolData[symbolName].ea,symbolData[symbolName].eb, symbolData[symbolName].bid,symbolData[symbolName].ask,symbolData[symbolName].is_session_active);
    setSelectedCategoryId(symbolData[symbolName].symbol_category);
    // setSelectedSymbolSession(symbolData[symbolName].is_session_active);
    // updateSymbolDetailsData(symbolName);
    setAuthSelectedCategory(symbolData[symbolName].symbol_category);
    setAuthSelectedSymbol(symbolName);
    setSelectedAuthSymbolId(symbolData[symbolName]?.id);
  };

  // Handle position row double click to open SL/TP modal
  const handlePositionRowDoubleClick = (row) => {
    if (!row || row._endOfList || row.is_bot_trade == 1) return;
    const currentPrice = row.direction === "Buy"
      ? symbolData[row.symbol]?.ask
      : symbolData[row.symbol]?.bid;
    
    const formattedPrice = parseFloat(currentPrice);
    setSelectedPosition({ ...row, current_price: formattedPrice });
    showEditSltp();
  };

  const [currentPage, setCurrentPage] = useState(1)
  const positionsPerPage = 9;
  const indexOfLast = currentPage * positionsPerPage;
  const indexOfFirst = indexOfLast - positionsPerPage;
  const currentPositions = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / positionsPerPage);
  
  const currTab = document.body.getAttribute('mobileCurrentView');

  const handlePageChange = (pg) => {
    setCurrentPage(pg);
  };

  const clearAllPositions = async () => {
    closeAllPosition(user.userId);
  };

  const clearAllProfitablePositions = async () => {
    closeProfitablePositions(user.userId, 1);
  }

  const clearAllLosingPositions = async () => {
    closeLosingPositions(user.userId, 0);
  };

  const clearAllOrders = async () => {
    const currentDate = new Date();
    const currentDateTime = new Date(currentDate);
    closeAllOrder(user.userId);
  };

  const handleExpandCollapseRow = (e, id) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [id]: !prevExpandedRows[id],
    }));
  };

  // check SL and TP for each open position
  const checkSLTP = () => {
    let position_local = null;
    let currentPrice_local = null;

    for (const position of openPositions) {
      const currentPrice = position.current_price;
      if (currentPrice !== undefined) {
        if (position.direction === "Buy") {
          // For Buy positions
          if (position.SL > 0 && currentPrice <= position.SL) {
            // If current price is less than or equal to SL, get selected position and close it
            position_local = position;
            currentPrice_local = currentPrice;
            break;
          } else if (position.TP > 0 && currentPrice >= position.TP) {
            // If current price is greater than or equal to TP, get selected position and close it
            position_local = position;
            currentPrice_local = currentPrice;
            break;
          }
        } else {
          // For Sell positions
          if (position.SL > 0 && currentPrice >= position.SL) {
            // If current price is greater than or equal to SL, get selected position and close it
            position_local = position;
            currentPrice_local = currentPrice;
            break;
          } else if (position.TP > 0 && currentPrice <= position.TP) {
            // If current price is less than or equal to TP, get selected position and close it
            position_local = position;
            currentPrice_local = currentPrice;
            break;
          }
        }
      }
    }

    // if SL / TP hit any of the open position then close that position
    if (position_local && currentPrice_local) {
      setIsClosing(true);
      // setLoadingSymbolContext(true);
      closePosition(user.userId, position_local, currentPrice_local, metrics);
    }
  };

  // fetch opened positions and update the context with the retrieved data
  const getOpenedPositions = () => {
    try {
      if (platFromData && platFromData.length > 3 && platFromData[3] && platFromData[3]['openedPositions']) {
        if (user && user.userId != undefined && user.userId > 0) {
          const positions: Position[] = platFromData[3]['openedPositions'].map((obj) => {
            return {
              id: obj.id,
              created_at: obj.created_at,
              position_id: obj.id,
              symbol: obj.symbol,
              quantity: obj.quantity,
              direction: obj.direction,
              botFilter: obj.botFilter,
              entry_price: obj.entry_price,
              TP: obj.TP != 0 ? obj.TP : "",
              SL: obj.SL != 0 ? obj.SL : "",
              netEUR: 0, // Set appropriate values
              status: "",
              margin: obj.margin,
              pnl: obj.pnl,
              current_price: obj.current_price,
              formatted_date: obj.formatted_date,
              ask_price: obj.ask_price,
              bid_price: obj.bid_price,
              lot_step: obj.lot_step,
              is_bot_trade: obj.is_bot_trade
            };
          });

          setAllOpenPositions(positions);
        }

      }
    } catch (error) {
      console.error(`Error getting opened positions`, error);
    }
  };

  // fetch closed positions and update the context with the retrieved data
  const getClosedPositions = async () => {
    try {
      if (platFromData && platFromData.length > 3 && platFromData[3] && platFromData[3]['closedPositions']) {
        if (user && user.userId != undefined && user.userId > 0) {
          const positions: Position[] = platFromData[3]['closedPositions'].map((obj) => {
            // Map the properties from the received data to the desired format
            return {
              id: obj.id,
              created_at: new Date(obj.created_at), // Convert the string to a Date object
              position_id: obj.position_id,
              symbol: obj.symbol,
              quantity: obj.quantity,
              direction: obj.direction,
              entry_price: obj.entry_price,
              TP: obj.TP != 0 ? obj.TP : "",
              SL: obj.SL != 0 ? obj.SL : "",
              netEUR: 0, // Set appropriate values
              status: "",
              margin: obj.margin,
              exit_price: obj.exit_price,
              position_closed_at: new Date(obj.position_closed_at),
              formatted_date: obj.formatted_date,
              formatted_date_open: obj.formatted_date_open
            };
          });

          setAllClosePositions(positions);
        }
      }
    } catch (error) {
      console.error(`Error getting closed positions`, error);
    }
  };

  const getClosedOrders = async () => {
    try {
      if (platFromData && platFromData.length > 4 && platFromData[4] && platFromData[4]['closedOrders']) {
        if (user && user.userId != undefined && user.userId > 0) {
          const orders: Order[] = platFromData[4]['closedOrders'].map((obj) => {
            // Map the properties from the received data to the desired format
            return {
              id: obj.id,
              // created_at: new Date(obj.created_at), // Convert the string to a Date object
              status_updated_at: new Date(obj.status_updated_at),
              order_id: obj.order_id,
              symbol: obj.symbol,
              quantity: obj.quantity,
              direction: obj.direction,
              entry_price: obj.entry_price,
              TP: obj.TP != 0 ? obj.TP : "",
              SL: obj.SL != 0 ? obj.SL : "",
              netEUR: 0, // Set appropriate values
              status: obj.status,
              margin: obj.margin,
              exit_price: obj.exit_price,
            };
          });

          setAllCloseOrders(orders);
        }
      }
    } catch (error) {
      // Handle API request error
      // console.error(`API request error: ${API_ENDPOINT_CLOSED_ORDERS}`, error);
      console.error(`Error getting closed orders`, error);
    }
  };

  // fetch opened orders and update the context with the retrieved data
  const getOpenedOrders = () => {
    try {
      if (platFromData && platFromData.length > 4 && platFromData[4] && platFromData[4]['openedOrders']) {

        if (user && user.userId != undefined && user.userId > 0) {
          const orders: Order[] = platFromData[4]['openedOrders'].map((obj) => {
            // Map the properties from the received data to the desired format
            return {
              id: obj.id,
              created_at: obj.created_at,
              symbol: obj.symbol,
              quantity: obj.quantity,
              direction: obj.direction,
              botFilter: obj.botFilter,
              entry_price: obj.entry_price,
              TP: obj.TP != 0 ? obj.TP : "",
              SL: obj.SL != 0 ? obj.SL : "",
              netEUR: 0, // Set appropriate values
              status: "",
              margin: obj.margin,
              order_id: obj.order_id,
              current_price: obj.current_price
            };
          });
          setAllOpenOrders(orders);
        }
      }
    } catch (error) {
      console.error(`Error getting opened orders`, error);
    }
  };

  const handleTabClick = (tab: string) => {
    localStorage.setItem("accountManager", tab);
    setActiveTab(tab);
  };

  const calculatePNL = (
    direction: string,
    quantity: number,
    entryPrice: number,
    currentPrice: number
  ) => {
    let pnl = 0;
    if (direction === "Buy") {
      pnl = (currentPrice - entryPrice) * quantity;
    } else {
      pnl = (entryPrice - currentPrice) * quantity;
    }
    return pnl.toFixed(2);
  };

  const showEditSltp = () => {
    setIsEditSltpVisible(true);
  };

  const hideEditSltp = () => {
    setIsEditSltpVisible(false);
  };

  useEffect(() => {
    let timeoutId;
  
    const checkButtonRef = () => {
      if (buttonRef?.current) {
        buttonRef.current.click();
      } else {
        timeoutId = setTimeout(checkButtonRef, 5000);
      }
    };
    if (currTab === 'history') checkButtonRef();

    return () => clearTimeout(timeoutId);
  }, [currTab]);


  const positionDetails = (e) => {
    let element;
    if (e.target.parentNode.parentNode.tagName == "P") {
      element = e.target.parentNode.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.tagName == "DIV") {
      element = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.tagName == "BUTTON") {
      element = e.target.parentNode.parentNode.parentNode.parentNode;
    }
    const inp = document
      .getElementsByClassName("wm-parent")[0]
      .querySelectorAll("input");
    document
      .getElementsByClassName("wm-parent")[0]
      .setAttribute("aria-modal", "true");
    document.getElementsByClassName(
      "wmTitleDynamic"
    )[0].innerHTML = `${t('accountManager.positionInfo')} ${element.querySelectorAll("p")[1].innerText
    }`;
    document.getElementsByClassName(
      "wmTitleDynamic"
    )[1].innerHTML = `${t('accountManager.positionInfo')}: ${element.querySelectorAll("p")[1].innerText
    }`;
    document.getElementsByClassName(
      "wmDescriptionDynamic"
    )[0].innerHTML = `Current Symbol: ${element.querySelectorAll("p")[3].innerText
    }`;
    inp[0].value = element.querySelectorAll("p")[1].innerText;
    inp[1].value = element.querySelectorAll("p")[6].innerText;
    inp[2].value = element.querySelectorAll("p")[7].innerText;
    inp[3].value = element.querySelectorAll("p")[8].innerText;
    inp[4].value = element.querySelectorAll("p")[9].innerText;
    inp[4].setAttribute("role", element.querySelectorAll("p")[9].className);
    inp[5].value = element.querySelectorAll("p")[2].innerText;
    inp[6].value = element.querySelectorAll("p")[4].innerText;
    inp[7].value = element.querySelectorAll("p")[5].innerText;
    inp[7].setAttribute("role", element.querySelectorAll("p")[5].innerText);
    inp[8].value = element.querySelectorAll("p")[3].innerText;
  };
  const positionDetailsView = (e) => {
    setSelectedPosition(e);
    setIsEdit(true);
  };
  const formatPostitionId = (orderId) => {
    return orderId ? `PID${orderId.toString().padStart(8, "0")}` : "---";
  };

  const bulkConfirmActionLabel = () => {
    if (bulkOperationType === 'profitable') return t('actions.closeProfitablePositions');
    if (bulkOperationType === 'losing') return t('actions.closeLosingPositions');
    return t('actions.closeAllPositions');
  };
  
  const closeSelectedPosition = async (position) => {
    setSelPositionId((ids) => [...ids, position.position_id]);
    const closed = await closePosition(user.userId, position,
      position.direction === 'Buy' ? position.bid_price : position.ask_price, position.direction);
    if (!closed) setSelPositionId((ids) => ids.filter((id) => id !== position.position_id));
  };

  const columns = [
    {
      name: '',
      cell: (row) => (
        row._endOfList ? (
          <div className="no-more-inline">{t('tables.noMorePositions')}</div>
        ) : (
        <div className="positions-button">
          <button type="button" aria-label={t('accountManager.positionInfo')} className="modal-icon" onClick={() => positionDetailsView(row)}>
          <InfoHexIcon />
          </button>
          {
          
          row.is_bot_trade == 1 ? '' :
          <button
            className="modal-icon modal-icon-sltp"
            type="button" aria-label={t('editSltp.positionTitle')}
            onClick={() => {
              showEditSltp();
              setSelectedPosition(row)
            }}
          >
          <SettingsHexIcon />
          </button>
          }
          {Number(row.is_bot_trade) === 2 && (
            <span className="ea-type-badge" data-tooltip={t('actions.expertAdvisor')}>EA</span>
          )}
        </div>
        )
      ),
      ignoreRowClick: true,
      nonSortable: true,
      grow: 0,
      width: '90px',
      minWidth: '90px',
      maxWidth: '90px',
      wrap: false,
    },
  
    {
      name: t('tables.id'),
      id: 'id',
      selector: (row) => formatPostitionId(row.position_id),
      grow: 0,
      minWidth: '108px',
      wrap: false,
      cell: (row) => row._endOfList ? null : <span className="cell-id">{formatPostitionId(row.position_id)}</span>,
    }, 
    {
      name: t('tables.created'),
      id: 'created',
      selector: (row) =>
        row._endOfList ? '' : formatDate(adjustDateTime(row.created_at,utcOffset)),
      minWidth: '124px',
      grow: 1,
      wrap:false,
    },
    {
      name: t('tables.symbol'),
      id: 'symbol',
      selector: (row) => row._endOfList ? '' : row.symbol,
      grow: 1,
      minWidth: '80px',
      wrap:false,
    },
    {
      name: t('tables.quantity'),
      id: 'quantity',
      selector: (row) => row._endOfList ? '' : formatFixedTrimmed(row.quantity, 8),
      minWidth: '64px',
      grow: 1,
      wrap: false,
    },
    {
      name: t('tables.direction'),
      id: 'direction',
      selector: (row) => row._endOfList ? '' : row.direction,
      cell: (row) => (row._endOfList ? '' : translateDirection(row.direction, t)),
      grow: 1,
      minWidth: '72px',
      wrap:false,
    },
    {
      name: t('tables.margin'),
      id: 'margin',
      selector: (row) => row._endOfList ? '' : formatFixedTrimmed((row.margin * userCurrencyExchangeRate), 4),
      grow: 1,
      minWidth: '64px',
      wrap:false,
    },
    {
      name: t('tables.entry'),
      id: 'entry',
      selector: (row) => {
        if (row._endOfList) return '';
        const entryPrice = parseFloat(row?.entry_price);
        if (isNaN(entryPrice)) return "---";
        return formatFixedTrimmed(row.entry_price, 8);
      },
      grow: 1,
      minWidth: '72px',
      wrap:false,
    },
    {
      name: t('tables.current'),
      id: 'current',
      selector: (row) => {
        if (row._endOfList) return '';
        const currentPrice = parseFloat(row?.current_price);
        return isNaN(currentPrice) ? "---" : formatFixedTrimmed(currentPrice, 8);
      },
      grow: 1,
      minWidth: '72px',
      wrap:false,
    },
    {
      name: t('tables.pnl'),
      id: 'pnl',
      selector: (row) => {
        if (row._endOfList) return '';
        const pnlValue = (parseFloat(row?.pnl)* userCurrencyExchangeRate);
        if (isNaN(pnlValue)) return '---';
        return formatFixedTrimmed(pnlValue, 2);
      },
      grow: 1,
      minWidth: '64px',
      wrap: false,
      cell: (row) => {
        if (row._endOfList) return null;
        const pnlValue = (parseFloat(row?.pnl)* userCurrencyExchangeRate);
        if (isNaN(pnlValue)) return <span>---</span>;
        const color = pnlValue >= 0 ? selectedStyle.buyColor : selectedStyle.sellColor;
        return <span style={{ color }}>{formatFixedTrimmed(pnlValue, 2)}</span>;
      },
    },
    {
      name: t('tables.sl'),
      id: 'sl',
      selector: (row) => row._endOfList ? '' : (row.is_bot_trade == 1 ? '--' : String(row.SL) !== '' ? formatFixedTrimmed(row.SL, 8): '--'),
      grow: 1,
      minWidth: '56px',
      wrap:false,
    },
    {
      name: t('tables.tp'),
      id: 'tp',
      selector: (row) => row._endOfList ? '' : (row.is_bot_trade == 1 ? '--' : String(row.TP) !== '' ? formatFixedTrimmed(row.TP, 8): '--'),
      grow: 1,
      minWidth: '56px',
      wrap:false,
    },
    {
      id: 'close',
      name:(
          <button
            className="Close-button"
            disabled={isFirstLoginDisabled || openPositions.every(item => item.pnl == '-' || item.current_price == '-'|| item.pnl == null ||item.current_price == null ||((symbolData[item.symbol] && symbolData[item.symbol].is_session_active === 0))) || platFromData[3]?.keepPrevData || platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3 || localStorage.getItem('accountType') =="0"}
            onClick={(e) => clearPopup(e,"close all positions")}
            data-platformdata={platFromData[3]?.keepPrevData}
          >
            {isClosingAllPositions ? t('actions.closing') : t('actions.closeAll')}
          </button>
        ),
      cell: (position) => (
        position._endOfList ? null :
        position.is_bot_trade === 1 ? (
          <FaRobot style={{height: '1rem', width: '1rem'}} />
        ) :
        <div className="positions-close-button">
          <button
            title={
              !symbolData[position.symbol] 
                ? t('actions.symbolDisabled')
                : symbolData[position.symbol]?.is_session_active === 0 
                  ? t('actions.marketClosedForSymbol') 
                  : ""
            }           
            disabled={
              isFirstLoginDisabled ||
              platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3 || localStorage.getItem('accountType') =="0" || position.pnl == null ||selPositionId.includes(position.position_id) || position.current_price == null || platFromData[3]?.keepPrevData || isClosingPosition || 
              (symbolData[position.symbol] && symbolData[position.symbol].is_session_active === 0)
            }

            aria-label={t('editSltp.close')}
            className="close-icon"
            onClick={(e) => {
              closeSelectedPosition(position);
            }
            }
          >
            <FaTimes />
          </button>
        </div>
      ),
      grow: 0,
      width: '76px',
      minWidth: '76px',
      maxWidth: '76px',
      wrap:false,
      center: true,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center',
      },
    },
  ];
  createTheme(
    "solarized",
    {
      text: {
        primary: "var(--content-secondary, #b8bcc8)", // normalTextColor
      },
      background: {
        default: "var(--surface-panel, #252b42)", // firstBox
      },
      context: {
        background: "var(--surface-panel, #252b42)", // firstBox
        text: "var(--content-secondary, #b8bcc8)", // normalTextColor
      },
    },
    "dark"
  ); 
  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '4px',
        paddingRight: '4px',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'left',
      },
    },
    cells: {
      style: {
        paddingLeft: '4px',
        paddingRight: '4px',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'left',
        cursor: !mobileMode ? 'pointer' : undefined,
      },
    },
    pagination: {
      style: {
        // width: '100vw',
        minHeight: '30px',
        height: '30px'
      },
    },
    headRow: {
      style: {
        minHeight: '10px',
        height: '30px',
        backgroundColor: 'var(--surface-panel, #252b42)',
      },
      denseStyle: {
        minHeight: '10px',
        height: '30px'
      },
    },
    rows: {
      style: {
        minHeight: '35px',
      },
    },
  };
  const conditionalRowStyles = [
    {
      when: row => row._endOfList,
      style: {
        minHeight: '36px',
        height: '36px',
        cursor: 'default',
        backgroundColor: 'var(--surface-panel, #252b42)',
        borderBottomWidth: '0',
        '&:hover': { backgroundColor: 'var(--surface-panel, #252b42)' },
      },
    },
    {
      when: row => Number(row.is_bot_trade) === 1 && row.position_id !== selectedTableRowId,
      style: {
        backgroundColor: 'var(--surface-raised, #2f3549)',
        color: 'var(--content-primary, #e8eaf0)',
      },
    },
    {
      when: row => row.position_id != null && row.position_id === selectedTableRowId,
      classNames: ['am-row-selected'],
      style: {
        backgroundColor: '#323a54',
        color: 'var(--content-primary, #e8eaf0)',
        '&:hover': { backgroundColor: '#323a54' },
      },
    },
  ];
  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  return (
    <>
      {/* <div className="new-position-popup">
        <MarketOrder />
      </div> */}
        {isEdit && (
        <>
          <div 
            className="position-info-backdrop" 
          ></div>
          <PlatformModalLayer className="wm-parent" onDismiss={() => setIsEdit(false)} aria-label={t('accountManager.positionInfo')}>
            <div
              className="window-module"
              style={{ position: "fixed", top: "25%" , zIndex:999 }}
              onClick={(e) => e.stopPropagation()}
            >
            <div className="wm-header">
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <h2 className="wmTitleDynamic">
                  {t('accountManager.positionInfo')}<span className="popup-reference">PID{selectedPosition?.position_id
                      ? selectedPosition.position_id.toString().padStart(8, "0")
                      : "---"}</span>
                </h2>
                {selectedPosition?.is_bot_trade !==1 && (
                  <button type="button" aria-label={t('ea.positionDetails')}
                    onClick={handlePositionModal}
                    title={t('ea.positionDetails')}
                    style={{ 
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: 0,
                      padding: "6px",
                      backgroundColor: "var(--surface-bg, #1a1f36)",
                      borderRadius: "5px"
                    }}
                  >
                    <FaArrowUpRightFromSquare size={15} color="var(--content-primary, #e8eaf0)"/>
                  </button>
                )}
              </div>
              <PopupCloseButton className="position-window-close" onClick={() => {
                  setIsEdit(false);
                }} />
            </div>
            <div className="wm-content">
              {/* First row: Position ID, Created Date Time, Symbol Name, Direction (4 fields) */}
              <div className="input-content-wm">
                <div className="row row-4">
                  <div className="wm-read-p-in">
                    <p>{t('tables.positionId')}</p>
                    <input
                      type="text"
                      readOnly
                      value={`PID${selectedPosition?.position_id ? selectedPosition.position_id.toString().padStart(8, "0") : "---"}`}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>{t('tables.createdAt')}</p>
                    <input
                      type="text"
                      readOnly
                      value={`${new Date(
                        selectedPosition.created_at
                      ).toLocaleDateString("en-GB")}, ${new Date(
                        selectedPosition.created_at
                      ).toLocaleTimeString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}`}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>{t('tables.symbol')}</p>
                    <input
                      type="text"
                      readOnly
                      value={selectedPosition.symbol}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>{t('tables.direction')}</p>
                    <input
                      type="text"
                      readOnly
                      value={translateDirection(selectedPosition.direction, t)}
                    />
                  </div>
                {/* </div>
              </div> */}
              {/* Second row: Entry, Margin, Quantity, PNL (4 fields) */}
              {/* <div className="input-content-wm">
                <div className="row row-4"> */}
                  <div className="wm-read-p-in">
                    <p>{t('tables.entry')}</p>
                    <input
                      type="text"
                      readOnly
                      value={!isNaN(parseFloat(selectedPosition.entry_price)) ? formatFixedTrimmed(selectedPosition.entry_price, 8) : "---"}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>{t('tables.margin')}</p>
                    <input
                      type="text"
                      readOnly
                      value={formatFixedTrimmed(selectedPosition.margin, 4)}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>{t('tables.quantity')}</p>
                    <input
                      type="text"
                      readOnly
                      value={formatFixedTrimmed(selectedPosition.quantity, 8)}
                    />
                  </div>
                  <div className="wm-read-p-in">
                    <p>PNL</p>
                    <input
                      type="text"
                      readOnly
                      value={!isNaN(parseFloat(selectedPosition?.pnl)) ? formatFixedTrimmed(selectedPosition.pnl, 2) : "---"}
                    />
                  </div>
                </div>
              </div>
              {showDealsModal && <PositionEvent positionInfo={positionDealsInfo}/>}
            </div>
          </div>
        </PlatformModalLayer>
        </>
      )}
      {clearWindow === 'true' && (
        <ConfirmationHeroModal
          role={clearWindow}
          icon={<FaExclamationTriangle />}
          title={t('actions.closeAllPositions')}
          message={t('actions.confirmBulkForever', { action: bulkConfirmActionLabel() })}
          cancelLabel={t('common.cancel')}
          confirmLabel={t('common.confirm')}
          variant="danger"
          onCancel={() => setClearWindow('false')}
          onConfirm={(e) => popupAction(e)}
        />
      )}

      {/* Edit SLTP MODAL  */}
      {/* <EditSltp/> */}
      {isEditSltpVisible && <EditSltp  onCancel={hideEditSltp} editPositionId={selectedPosition.position_id} currentPrice={openPositions.find(
        (pos) => pos.symbol === selectedPosition.symbol && pos.position_id === selectedPosition.position_id
      )
      } />}

      <div className="tabs-section-acc global-platfrom">
        <div className="account-tabs-scroll-rail">
        <button type="button" className="account-tabs-scroll-arrow" hidden={!tabOverflow.overflow} disabled={!tabOverflow.left}
          aria-label={t('accountManager.scrollTabsLeft', { defaultValue: 'Scroll tabs left' })} onClick={() => scrollAccountTabs(-1)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m15 6-6 6 6 6" /></svg>
        </button>
        <div className="tabs-acc account-tabs-animated" ref={accountTabsRef}>
          <span className="account-tab-line" ref={accountTabLineRef} aria-hidden="true" />
          <button
            className={`tab-button-acc ${activeTab === "open-positions-acc" ? "tab-active-acc" : ""
              }`}
            onClick={(e) => {
              handleTabClick("open-positions-acc");
              // mkRipple(e);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="open-positions-acc"
          >
            <Ripple />
            {t('accountManager.positions')} <span id="countPositions">{filteredData.length}</span>
          </button>
          <button
            className={`tab-button-acc ${activeTab === "open-orders-acc" ? "tab-active-acc" : ""
              }`}
            onClick={(e) => {
              handleTabClick("open-orders-acc");
              // mkRipple(e);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="open-orders-acc"
          >
            <Ripple />
            {t('accountManager.orders')} <span id="countOrders">{openOrdersCountD}</span>
          </button>
          <button
            className={`tab-button-acc ${activeTab === "history-acc" ? "tab-active-acc" : ""
              }`}
            onClick={(e) => {
              handleTabClick("history-acc");
              // mkRipple(e);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="history-acc"
          >
            <Ripple />
            {t('accountManager.positionHistory')}{" "}
            <span id="countHistory">{positionHistoryCount}</span>
          </button>
          <button
            className={`tab-button-acc ${activeTab === "history-orders" ? "tab-active-acc" : ""
              }`}
            onClick={(e) => {
              handleTabClick("history-orders");
              // mkRipple(e);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="history-orders"
          >
            <Ripple />
            {t('accountManager.orderHistory')}{" "}
            <span id="countOrdersHistory">{orderHistoryCount}</span>
          </button>
          {showBotHistoryTab && (
          <button
            className={`tab-button-acc ${activeTab === "bot-positions-history" ? "tab-active-acc" : ""
              }`}
            onClick={() => {
              handleTabClick("bot-positions-history");
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="history-orders"
          >
            <Ripple />
            {t('accountManager.botPositionHistory')}{" "}
            {botHistoryPending && <i className="bot-history-new" title={t('ea.botHistoryRefreshHint')} aria-label={t('ea.botHistoryLoadNew')}></i>}
            <span id="countBotHistory">{botPositionHistoryCount}</span>
          </button>
          )}
          {showEaStrategiesModule && (
          <button
            className={`tab-button-acc ${activeTab === "ea-strategies" ? "tab-active-acc" : ""
              }`}
            onClick={() => {
              handleTabClick("ea-strategies");
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="ea-strategies"
          >
            <Ripple />
            {t('accountManager.strategies')} <span id="countStrategies">{strategiesCount}</span>
          </button>
          )}
          {/* <button
            className={`tab-button-acc ${activeTab === "account-history-acc" ? "tab-active-acc" : ""
              }`}
            onClick={(e) => {
              handleTabClick("account-history-acc");
              // mkRipple(e);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            data-tab="account-history-acc"
          >
            <Ripple />
            Account History <span id="countAccountHistory">0</span>
          </button> */}
        </div>
        <button type="button" className="account-tabs-scroll-arrow" hidden={!tabOverflow.overflow} disabled={!tabOverflow.right}
          aria-label={t('accountManager.scrollTabsRight', { defaultValue: 'Scroll tabs right' })} onClick={() => scrollAccountTabs(1)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
        </button>
        </div>
        <div
          className={`tab-content-acc ${activeTab === "open-positions-acc" ? "tab-content-active-acc" : ""
            }`}
          id="open-positions-acc"
        >
          <div className="pos-section">
            {/* <Positions /> */}
            <div className="open-positions-table bottom-table-bstorm"  style={{ overflow: "hidden" }} >
            {/* , position: "absolute", zIndex: 0 */}
            <div className="positions-button history-filters">
              <div className="hf-group hf-search">
                <div className="input-text">
                  <input
                    type="text"
                    value={filterText}
                    onChange={handleFilter}
                    placeholder={t('tables.searchSymbol')}
                  />
                  <div className="input-svg" id="searchSvgColor">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="11"
                      fill="currentColor"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="hf-group hf-type">
                <span className="hf-label">{t('filters.positions')}</span>
                <div className="hf-pills" role="group" aria-label={t('ea.positionType')}>
                  <button
                    type="button"
                    className={botFilter === 'all' ? 'active' : ''}
                    onClick={() => handleBotFilterChange('all')}
                  >
                    {t('common.all')}
                  </button>
                  <button
                    type="button"
                    className={botFilter === 'nonBot' ? 'active' : ''}
                    onClick={() => handleBotFilterChange('nonBot')}
                  >
                    {t('filters.noBot')}
                  </button>
                  <button
                    type="button"
                    className={botFilter === 'isBot' ? 'active' : ''}
                    onClick={() => handleBotFilterChange('isBot')}
                  >
                    {t('common.bot')}
                  </button>
                  <button
                    type="button"
                    className={botFilter === 'isEa' ? 'active' : ''}
                    onClick={() => handleBotFilterChange('isEa')}
                  >
                    {t('filters.ea')}
                  </button>
                </div>
              </div>

              <div className="hf-group hf-direction">
                <span className="hf-label">{t('filters.direction')}</span>
                <Select
                  options={directionOptions}
                  value={directionOptions.find((option) => option.value === direction)}
                  onChange={handleSelectChange}
                  styles={customStyle}
                  menuPortalTarget={document.body}
                  isSearchable={false}
                  classNamePrefix="history-direction"
                />
              </div>
            </div>
            <div className="table-scroll-area" ref={positionsTableScrollRef}>
              {!mobileMode && activeTab === "open-positions-acc" && <DataTable
              className="history-rdt"
              columns={columns}
              progressPending={loading}
              progressComponent={<PanelSkeleton tableColumns={columns} />}
              data={filteredData}
              persistTableHead
              responsive={false}
              fixedHeader={false}
              pagination={false}
              theme="solarized"
              customStyles={customStyles}
              conditionalRowStyles={conditionalRowStyles}
              paginationComponentOptions={paginationComponentOptions}
              noDataComponent={<NoRecordsMessage variant="positions" />}
              pointerOnHover
              onRowClicked={(row) => {
                if (!row || row._endOfList) return;
                setSelectedTableRowId(row.position_id);
                handleRowClick(row);
              }}
              onRowDoubleClicked={handlePositionRowDoubleClick}
            />}
            {!mobileMode && filteredData.length > 0 && (
              <div className="no-more-inline">{t('tables.noMorePositions')}</div>
            )}
            </div>
           
            </div>
          </div>
        </div>
        <div
          className={`tab-content-acc ${activeTab === "open-orders-acc" ? "tab-content-active-acc" : ""
            }`}
          id="open-orders-acc"
        >
          {/* Orders content will be added here */}
          <div className="pos-section">

            {!mobileMode && <Orders renderRows={activeTab === "open-orders-acc"} loading={loading} openOrders={openOrders} handleOpenOrdersUpdate={handleOpenOrdersDesktop} handleRowClick={handleRowClick} isSymbolSelecting={isSymbolSelecting} />}
          </div>
        </div>
        <div
          className={`tab-content-acc ${activeTab === "history-acc" ? "tab-content-active-acc" : ""
            }`}
          id="history-acc"
        >
         {!mobileMode && <PositionHistory renderRows={activeTab === "history-acc"} name={"positionHistory"} handleRowClick={handleRowClick} />}
        </div>
        <div
          className={`tab-content-acc ${activeTab === "history-orders" ? "tab-content-active-acc" : ""
            }`}
          id="history-orders"
        >
          {!mobileMode && <OrderHistory renderRows={activeTab === "history-orders"} name={"orderHistory"} handleRowClick={handleRowClick} isSymbolSelecting={isSymbolSelecting} />}
        </div>
        {showBotHistoryTab && (
        <div
          className={`tab-content-acc ${activeTab === "bot-positions-history" ? "tab-content-active-acc" : ""
            }`}
          id="bot-positions-history"
        >
         {!mobileMode && <BotPositionHistory renderRows={activeTab === "bot-positions-history"} name={"position-history-bot"} handleRowClick={handleRowClick} isSymbolSelecting={isSymbolSelecting} mobileMode={mobileMode} />}
         </div>
        )}
        {showEaStrategiesModule && (
        <div
          className={`tab-content-acc ${activeTab === "ea-strategies" ? "tab-content-active-acc" : ""
            }`}
          id="ea-strategies"
        >
          <StrategiesTab renderRows={!mobileMode && activeTab === "ea-strategies"} />
        </div>
        )}
        <div
          className={`tab-content-acc ${activeTab === "account-history-acc" ? "tab-content-active-acc" : ""
            }`}
          id="account-history-acc"
        >
          <div className="overflow-y-table-body">
            <br /><br /><br />
            <div className="f-center">
              <svg viewBox="0 0 86 59" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 17.5H66M17.5 17.5L1 1M17.5 17.5L31 39L17.5 58.5M17.5 58.5H66M17.5 58.5L1 51.5L17.5 39L1 1M66 58.5L84 51.5L66 39L84 1M66 58.5L53.5 39L66 17.5M66 17.5L84 1M1 1H84" />
                <path d="M33 6L37.5 12.5M42.5 12.5V6M47.5 12.5L52.5 6" />
              </svg>
            </div>
          </div>
        </div>
        {/* Legacy desktop metrics replaced by the full-width AccountStatsBar.
        <hr />
        <div className="metric-parent global-platfrom1">
          <MetricsPanel />
        </div>
        */}
      </div>

      {/* Just positions on mobile */}

      <div id="accountHistory" className="global-platfrom">
        <div
          className="tabs-ah-mb tabs-container-account-mb"
          draggable={false}
          ref={tabMenuRef}
        >
          <button
            className={`tab-button-mb ${
              activeHistoryTab === 0 ? 'active-tab-account-mb' : ''
            }`}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            onClick={() => {
              selectTab(0);
            }}
          >
            <Ripple />
            {t('accountManager.positions')} <span>{filteredData.length}</span>
            {
              activeHistoryTab === 0
              ? <div className="active-tab-mb" />
              : <div className="non-active-tab-mb" />
            }
          </button>
          <button
            className={`tab-button-mb ${
              activeHistoryTab === 1 ? 'active-tab-account-mb' : ''
            }`}
            onClick={() => {
              selectTab(1);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            <Ripple />
            {t('accountManager.positionsHistory')} <span>{positionHistoryCount}</span>
            {
              activeHistoryTab === 1
              ? <div className="active-tab-mb" />
              : <div className="non-active-tab-mb" />
            }
          </button>
          <button
            className={`tab-button-mb ${
              activeHistoryTab === 2 ? 'active-tab-account-mb' : ''
            }`}
            onClick={() => {
              selectTab(2);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            <Ripple />
            {t('accountManager.orders')} <span>{openOrdersCountM}</span>
            {
              activeHistoryTab === 2
              ? <div className="active-tab-mb" />
              : <div className="non-active-tab-mb" />
            }
          </button>
          <button
            className={`tab-button-mb ${
              activeHistoryTab === 3 ? 'active-tab-account-mb' : ''
            }`}
            onClick={() => {
              selectTab(3);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            <Ripple />
            {t('accountManager.orderHistory')} <span>{orderHistoryCount}</span>
            {
              activeHistoryTab === 3
              ? <div className="active-tab-mb" />
              : <div className="non-active-tab-mb" />
            }
          </button>

              {showBotHistoryTab && (
              <button
                className={`tab-button-mb ${
                  activeHistoryTab === 4 ? "active-tab-account-mb" : ""
                }`}
                onClick={() => selectTab(4)}
                style={{
                  position: "relative",
                  overflow: "hidden",
                  isolation: "isolate",
                }}
              >
                <Ripple />
                {t('accountManager.botPositionHistory')}{" "}
            {botHistoryPending && <i className="bot-history-new" title={t('ea.botHistoryRefreshHint')} aria-label={t('ea.botHistoryLoadNew')}></i>}
                <span>{botPositionHistoryCount}</span>
                {activeHistoryTab === 4 ? (
                  <div className="active-tab-mb" />
                ) : (
                  <div className="non-active-tab-mb" />
                )}
              </button>
              )}
          {/* <button
            className={`tab-button-mb ${
              activeHistoryTab === 4 ? 'active-tab-account-mb' : ''
            }`}
            onClick={() => {
              selectTab(4);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            <Ripple />
            Account History <span>0</span>
            {
              activeHistoryTab === 4
              ? <div className="active-tab-mb" />
              : <div className="non-active-tab-mb" />
            }
          </button> */}
        </div>

        <div className="tabs-ah-mb-data" ref={tabXDataRef} >
          <div className={`data-x-atomic ${activeHistoryTab === 0 ? 'data-x-atomic-active' : ''}`}>
            <div className="positions-button history-filters">
              <div className="hf-group hf-search">
                <div className="input-text">
                  <input
                    type="text"
                    value={filterText}
                    onChange={handleFilter}
                    placeholder={t('tables.searchSymbol')}
                  />
                  <div className="input-svg" id="searchSvgColor">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="hf-group hf-direction">
                <span className="hf-label">{t('filters.direction')}</span>
                <Select
                  options={directionOptions}
                  value={directionOptions.find((option) => option.value === direction)}
                  onChange={handleSelectChange}
                  styles={customStyle}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  classNamePrefix="history-direction"
                />
              </div>
            </div>
            <div className="mobile-positions-wrapper">
              {loading ? <PanelSkeleton /> : filteredData.length > 0 ? (
                <>
                  <MobilePositionsList positions={currentPositions} />
                  {filteredData.length > positionsPerPage && (
                    <div className="pagination-controls">
                      <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                            viewBox="0 0 16 16">
                          <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                          <path d="M7.354 1.146a.5.5 0 0 1 0 .708L2.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                        </svg>
                      </button>
                    
                      <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                            viewBox="0 0 16 16">
                          <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                        </svg>
                      </button>
                    
                      <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                            viewBox="0 0 16 16">
                          <path d="M4.646 1.146a.5.5 0 0 1 .708 0l5.5 5.5a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 1 1-.708-.708L9.793 7 4.646 1.854a.5.5 0 0 1 0-.708z"/>
                        </svg>
                      </button>
                    
                      <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                            viewBox="0 0 16 16">
                          <path d="M4.646 1.146a.5.5 0 0 1 .708 0L10.5 6.293 5.354 11.44a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          <path d="M8.646 1.146a.5.5 0 0 1 .708 0L14.5 6.293 9.354 11.44a.5.5 0 1 1-.708-.708L13.293 7 8.646 2.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                      </button>
                    </div>                  
                  )}
                </>
              ) : ( 
                <div className="no-positions">{t('accountManager.noOpenPositions')}</div>
              )}
            </div>
          </div>
          <div className={`data-x-atomic ${activeHistoryTab === 1 ? 'data-x-atomic-active' : ''}`}>
            <div className="mob-position-tab">
              {mobileMode && <PositionHistory name={"position-history"}/>}
            </div>
          </div>
          <div className={`data-x-atomic ${activeHistoryTab === 2 ? 'data-x-atomic-active' : ''}`}>
            <div className="mob-position-tab" ref={ordersDivRef}>
              {mobileMode && <Orders
                openOrders={openOrders}
                currTab={currTab}
                parentRef={ordersDivRef}
                handleOpenOrdersUpdate={handleOpenOrdersMobile}
                />}
            </div>
          </div>
          <div className={`data-x-atomic ${activeHistoryTab === 3 ? 'data-x-atomic-active' : ''}`}>
            <div className="mob-position-tab" ref={orderHistoryDivRef}>
              {mobileMode && <OrderHistory
                name={'order-history'}
                currTab={currTab}
                parentRef={orderHistoryDivRef}
              />}
            </div>
          </div>
          {showBotHistoryTab && (
          <div className={`data-x-atomic ${activeHistoryTab === 4 ? 'data-x-atomic-active' : ''}`}>
            <div className="mob-position-tab">
              {mobileMode && <BotPositionHistory name={"positionHistoryBot"} handleRowClick={handleRowClick} isSymbolSelecting={isSymbolSelecting} mobileMode={mobileMode}/>}
            </div>
          </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountManager;
